import clsx from 'clsx';

interface Props {
  size?: number;
  className?: string;
  /** Cor de fundo do quadrado. Default = Azul Diamante Apex (#0076D2 do brand guideline). */
  bg?: string;
  /** Cor do diamante. Default = branco. */
  fill?: string;
}

/**
 * Logo Apex (símbolo) — diamante branco em quadrado azul (#0076D2 Azul Diamante Apex).
 * Conforme Brand Guideline oficial Apex Partners.
 */
export function BrandLogo({ size = 32, className, bg = '#0076D2', fill = '#FFFFFF' }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('shrink-0', className)}
      aria-label="Apex Partners"
    >
      <rect width="100" height="100" rx="6" fill={bg} />
      <polygon points="50,28 72,50 50,72 28,50" fill={fill} />
    </svg>
  );
}

/**
 * Logo Apex completo — quadrado + wordmark "APEX".
 * Usado em locais que precisam da marca completa (hero do login etc).
 */
export function BrandWordmark({ size = 32, className, color = 'currentColor' }: { size?: number; className?: string; color?: string }) {
  return (
    <div className={clsx('inline-flex items-center gap-2', className)} aria-label="Apex">
      <BrandLogo size={size} />
      <span
        className="font-extrabold tracking-tight"
        style={{ fontSize: size * 0.75, color, fontFamily: 'Manrope, sans-serif', letterSpacing: '0.04em' }}
      >
        APEX
      </span>
    </div>
  );
}
